/** @jsx jsx */

import React, { Fragment as _, useState, useRef, useContext } from 'react';
import { css, jsx } from '@emotion/core';
import { interactionContext as _interactionContext_ } from './interactionContext';
import { MediaContext } from 'components/lib/Media/Media';
import { getDefaultStyles } from 'components/lib/ClickAndReveal/clickAndRevealConfig';

const Content = ({ layout, children }) => {
  const [mediaChanged, setMediaChanged] = useState(children.props.child);

  let minHeightInDev =
    window.dev() && [1, 3].includes(mediaChanged) ? `min-height: 50vh;` : '';

  return (
    <MediaContext.Provider
      value={{
        onMediaChange(child) {
          if (mediaChanged !== child) {
            setMediaChanged(child);
          }
        },
      }}
    >
      <div
        css={css`
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          width: ${layout.includes('Two') ? '50%' : '100%'};
          margin: ${layout.includes('Two') ? '0 10px' : '10px 0'};
          ${minHeightInDev}
          @media (max-width: 768px) {
            width: 100%;
          }
        `}
      >
        {children}
      </div>
    </MediaContext.Provider>
  );
};

const ClickAndRevealContent = props => {
  const interactionContext = useContext(_interactionContext_);

  const clickAndRevealDefaultStyles = getDefaultStyles(
    interactionContext?.meta?.packageVersion
  );

  const {
    layout = clickAndRevealDefaultStyles.layout,
  } = interactionContext?.props;

  const { onClose, children } = props;
  const [columnA, columnB, btn] = children;

  const DOMLayout = {
    'Two column': [columnA, columnB],
    'Two column reversed': [columnB, columnA],
    'One column': [columnA, columnB],
    'One column reversed': [columnB, columnA],
    'No image': [columnA],
  }[layout];

  return (
    <div
      css={css`
        width: 100%;
        padding: 50px;
      `}
    >
      <div
        css={css`
          width: 100%;

          ${layout.includes('Two') &&
            `
            display: flex;
            
          @media (max-width: 768px) {
        display: block;
          `}
        `}
      >
        <Content layout={layout}>{DOMLayout[0]}</Content>

        {layout !== 'No image' && (
          <Content layout={layout}>{DOMLayout[1]}</Content>
        )}
      </div>
      <div
        css={css`
          display: flex;
          justify-content: center;
          width: 100%;
          margin: 30px 0 0 0;
        `}
      >
        {React.cloneElement(btn, { onClick: () => onClose() })}
      </div>
    </div>
  );
};

export default ClickAndRevealContent;
